import { Component } from '@angular/core';

@Component({
  selector: 'app-open12-info-component',
  imports: [],
  templateUrl: './open12-info-component.html',
  styleUrl: './open12-info-component.scss'
})
export class Open12InfoComponent {

}
